module.exports = __webpack_public_path__ + "static/media/ee_ru_desk_s.012d323b.png";